const isCorrectWord = (word: string, correctWord: string) => {
  return word === correctWord
}

export default isCorrectWord